var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('PropertiesCatalogTable',{attrs:{"items":_vm.properties,"pagination-data":_vm.pagination,"hover":"","striped":"","small":"","fixed":"","caption":"Inventario de Propiedades"},on:{"refreshItems":_vm.refreshItems}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }